

































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import {
    AccessHours,
    TransportParty,
    TransportTask
} from "../models";

@Component
export default class Address extends Vue {
    @Prop() title!: string;
    @Prop() party!: TransportParty | { city: string, zipCode: string };
    @Prop() location!: { latitude: number, longitude: number } | null;
    @Prop() task!: TransportTask | null;
    @Prop() customerAddress!: string | null;
    @Prop() accessHours!: AccessHours | null;

    get canNavigate() {
        return !!navigator.geolocation;
    }

    get navigateUrl() {
        const userAgent = navigator.userAgent.toLowerCase();
        const isAndroid = userAgent.indexOf("android") !== -1;
        const isIos = userAgent.match(/(iPod|iPhone|iPad)/i);

        const saddr = isAndroid ? "" : isIos ? "Current Location" : "";

        const daddr = this.daddr;

        return `http://maps.google.com?saddr=${encodeURIComponent(
            saddr
        )}&daddr=${encodeURIComponent(daddr)}`;
    }

    get daddr(): string {
        if (this.location && this.location.latitude && this.location.longitude) {
            return this.location.latitude + "," + this.location.longitude;
        }

        if (this.customerAddress) {
            return this.customerAddress;
        }

        if (!("partyId" in this.party)) {
            return this.party.city;
        }

        const party: TransportParty = this.party as TransportParty;

        const address = party.streetAddress.split(",")[0];

        return party.latitude && party.longitude
            ? party.latitude + "," + party.longitude
            : address
            ? address + ", " + party.city
            : party.city;
    }

    get accessHoursText(): null | string {
        const hours = this.accessHours;
        if (!hours) {
            return null;
        }

        if (hours.always) {
            return this.$t("addressCard.accessHoursAlways").toString();
        }

        return hours.weekdays
            .filter(d => d.open < d.close)
            .map(d => `${this.$t("weekdays." + d.day)} ${this.formatTime(d.open)}-${this.formatTime(d.close)}`)
            .join(", ");
    }

    formatTime(minutes: number): string {
        return (Math.floor(minutes / 60).toString() as any).padStart(2, "0") + ":" + ((minutes % 60).toString() as any).padStart(2, "0");
    }
}
